import Mixin from 'mixmatch';

export default class Create extends Mixin {
  get createAction() {
    // @ts-ignore
    return this.collection();
  }

  async create(object) {
    const options = {
      method: 'POST',
      path: this.createAction,
      // @ts-ignore
      body: this.attributesForObject(object),
    };
    // @ts-ignore
    const body = await this.call(options);
    // @ts-ignore
    return JSON.parse(body)[this.resourceName];
  }
}
